import { useCallback } from 'react';
import SelectCompany from 'src/components/SelectCompany';
import useCompany from 'src/hooks/useCompany';
import useGuideMe from 'src/hooks/useGuideMe';
import { Company } from 'src/types/Companies';
import { useGuideMeSteps } from './GuideMeSteps';

const ViewDepartmentNavbar = () => {
  const { changeCompany, company } = useCompany();
  const handleCompanyChange = useCallback(
    (company: Company) => {
      changeCompany(company);
    },
    [changeCompany]
  );

  const { guideMe } = useGuideMe({
    steps: useGuideMeSteps(),
    guideId: 'view-department',
  });

  return (
    <>
      <div className="flex justify-between items-center flex-wrap min-h-[56px]">
        <div className="flex">
          <SelectCompany className="items-center" onChange={handleCompanyChange} isControlled />
        </div>
        {!!company.companyId && <div className="flex">{guideMe}</div>}
      </div>
    </>
  );
};

export default ViewDepartmentNavbar;
